module.exports = __webpack_public_path__ + "img/service-flow-planner-2_m.7dee77e0.svg";